import * as React from "react"
import { Container } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { Contact } from "../components/contact"
import { Layout } from "../components/layout"
import { Head } from "../components/seo"


export const AutonomousVehiclePage: React.FC = () => {
  const { t } = useTranslation("translations", { keyPrefix: "AUTONOMOUS_VEHICLE" })

  return (
    <Layout title="AUTONOMOUS VEHICLE" subtitle={t("SUBTITLE")}>
      <Head title="AUTONOMOUS VEHICLE" />
      <Container className="my-5">
        <h3 className="mb-4">{t("DEVELOPMENT_OF_AUTONOMOUS_VEHICLE")}</h3>
        <p>{t("DESC_1")}</p>
        <p>{t("DESC_2")}</p>

        <h4 className="mt-4">{t("WORKS.TITLE")}</h4>
        <ul>
          <li>{t("WORKS.1")}</li>
          <li>{t("WORKS.2")}</li>
          <li>{t("WORKS.3")}</li>
          <li>{t("WORKS.4")}</li>
          <li>{t("WORKS.5")}</li>
          <li>{t("WORKS.6")}</li>
        </ul>

        <h4>{t("SERVICE_MENU_TITLE")}</h4>
        <ul>
          <li><a href="/turtlebot">{t("SERVICE_MENU_1")}</a></li>
        </ul>

        <div className="movie-wrap">
          <iframe title="Autonomous Vehicle Demo" className="youtube-re" width="560" height="315" src="https://www.youtube.com/embed/-rsrbCxM2gQ" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen={true} ></iframe>
        </div>
        <p>{t("VIDEO_DESC")}</p>
        <p>{t("CONTACT_US")}</p>
      </Container>
      <Contact />
    </Layout>
  )
}